import { IconLiquidity, theme } from '@capitalise/ui-design-system';
import { formatCurrency } from 'utils/NumberHelper';
import ProductInfo from './ProductInfo';
import PropTypes from 'prop-types';

const ProductFinanceDescription = ({ maximumCreditLine, serviceFee, discountFee, advanceRate }) => {
  return (
    <>
      <ProductInfo
        value={formatCurrency(maximumCreditLine)}
        label="Maximum credit limit"
        icon={<IconLiquidity color="grey-500" width={theme.sizes['tiny']} />}
      />
      <ProductInfo value={`${serviceFee} %`} label="Service fee" icon={'%'} />
      <ProductInfo value={`${discountFee} %`} label="Discount fee" icon={'%'} />
      <ProductInfo value={`${advanceRate} %`} label="Advance rate" icon={'%'} />
    </>
  );
};

ProductFinanceDescription.propTypes = {
  maximumCreditLine: PropTypes.number,
  serviceFee: PropTypes.number,
  discountFee: PropTypes.number,
  advanceRate: PropTypes.number,
};

export default ProductFinanceDescription;
